import {
  Document,
  People,
  Notification,
  TickSquare,
  Folder,
  Bag,
  Wallet,
  Chart,
  Danger,
  Paper,
  Discovery,
  Category,
} from "react-iconly";

const pages = [
  {
    id: "dashboard",
    title: "Dashboard",
    navLink: "/dashboard",
    icon: <Category set="curved" size="small" />,
  },
  {
    header: "CRM",
  },
  {
    id: "leads",
    title: "Leads",
    navLink: "/crm/leads",
    icon: <People set="curved" size="small" />,
  },
  {
    id: "enquiry",
    title: "Enquiry",
    navLink: "/crm/enquiry",
    icon: <Folder set="curved" size="small" />,
  },
  {
    header: "Sales",
  },
  {
    id: "flexiquote",
    title: "PI Quote",
    navLink: "/flexiquote",
    icon: <Bag set="curved" size="small" />,
  },
  {
    id: "salesquotation",
    title: "Sales Quotation",
    navLink: "/salesquotation",
    icon: <Wallet set="curved" size="small" />,
  },
  {
    id: "salesorder",
    title: "Sales Order",
    navLink: "/salesorder",
    icon: <Bag set="curved" size="small" />,
  },
  {
    id: "invoice",
    title: "Invoice",
    navLink: "/invoice",
    icon: <Document set="curved" size="small" />,
  },
  {
    header: "Reports",
  },
  {
    id: "reports",
    title: "Reports List",
    navLink: "/reports/reportsList",
    icon: <Discovery set="curved" size="small" />,
  },
  {
    id: "dynamicreports",
    title: "Dynamic Reports",
    navLink: "/reports/dynamic-reports",
    icon: <Chart  set="curved" size="small" />,
  },
  {
    header: "Others",
  },
  {
    id: "bpmaster",
    title: "BP Master Data",
    navLink: "/bpmasterlist",
    icon: <TickSquare set="curved" size="small" />,
  },
  {
    id: "complaints",
    title: "Customer Complaints",
    navLink: "/customercomplaints",
    icon: <Paper set="curved" size="small" />,
  },
  {
    id: "notification",
    title: "Notification",
    navLink: "/notification",
    icon: <Notification set="curved" size="small" />,
  },
  {
    id: "task",
    title: "Task",
    navLink: "/task",
    icon: <Danger set="curved" size="small" />,
  },
  // {
  //     header: "Approvals",
  // },
  // {
  //     id: "approvals",
  //     title: "Approvals List",
  //     navLink: "/approvals",
  //     icon: <TickSquare set="curved" size='small' />,
  // },
];

export default pages;
